import React from "react";
import AppTheme from "../../../../service/app_config/AppTheme";
import { IconNormal } from "../../../../widget/common/ui/Icon";
import { navigate } from "../../../../service/navigation/Navigation";
import { appRoutes } from "../../../../routes/routes";

const SettingsPersonalInfoActions = () => {
  const onClickDeactivate = () => {
    navigate(appRoutes.routeNameSettingsDeactivateAccountAlert);
  };

  return (
    <>
      <IconNormal
        name="edit_follow"
        color={AppTheme.themeFont}
        handleClick={() => onClickDeactivate()}
      />
    </>
  );
};

export default SettingsPersonalInfoActions;
